import type React from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { CompanyStoreSettingForm } from "~/components/specifics/settings/company_store_settings/CompanyStoreSettingForm";
import useItandiAccount from "~/hooks/useItandiAccount";
import SettingStyles from "../SettingStyle.module.scss";

export const Page: React.FC = () => {
	const { data: session } = useItandiAccount().currentAccount();
	return (
		<DefaultV2>
			<ClientSettingLayout>
				<h2 className={SettingStyles.SettingTitle}>店舗項目設定</h2>
				{session !== null && session.store ? (
					<CompanyStoreSettingForm companyStoreSetting={session.store} />
				) : null}
			</ClientSettingLayout>
		</DefaultV2>
	);
};
